var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.75c-3.119 0-5.725-1.533-7.77-4.052-1.364-1.68-2.48-3.95-2.48-4.698 0-.748 1.117-3.017 2.481-4.698C6.277 4.782 8.882 3.25 12 3.25c3.118 0 5.723 1.533 7.769 4.052 1.364 1.68 2.481 3.95 2.481 4.698 0 .748-1.116 3.017-2.48 4.698-2.045 2.519-4.651 4.052-7.77 4.052zm0-1.5c2.611 0 4.822-1.3 6.605-3.498 1.167-1.437 2.145-3.425 2.145-3.752 0-.327-.978-2.314-2.146-3.752C16.82 6.05 14.61 4.75 12 4.75s-4.82 1.3-6.604 3.498C4.228 9.685 3.25 11.673 3.25 12c0 .327.978 2.315 2.145 3.752C7.178 17.95 9.389 19.25 12 19.25zm0-11a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5zm0 1.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.112cd06e.svg";
export { ForwardRef as ReactComponent };